<template>
    <footer
        class="easy-footer"
        :style="{ 'font-family': footer.fontFamily, 'background-color': footer.background }"
    >
        <c-container :footer="footer">
            <c-newsletter
                v-if="!footer.simple && footer.newsletter && footer.newsletterLayout == 'maxi'"
                :footer="footer"
            />
            <template v-if="!footer.simple">
                <v-nav-left v-if="footer.variant == 'left'" :footer="footer" />
                <v-nav-center v-if="footer.variant == 'center'" :footer="footer" />
                <v-nav-below v-if="footer.variant == 'below'" :footer="footer" />
            </template>
            <cAddressFull
                class="mt-4"
                v-if="!footer.simple && footer.contactInfo && footer.contactLayout == 'full'"
                :footer="footer"
            />
            <c-newsletter-midi
                v-if="!footer.simple && footer.newsletter && footer.newsletterLayout == 'midi'"
                :footer="footer"
            />
            <c-copy-terms :footer="footer" />
        </c-container>
    </footer>
</template>

<script>
import cCopyTerms from "./components/cCopyTerms.vue";
import cContainer from "./components/cContainer.vue";
import cNewsletter from "./components/cNewsletter.vue";
import cNewsletterMidi from "./components/cNewsletterMidi.vue";
import vNavLeft from "./variants/vNavLeft.vue";
import vNavCenter from "./variants/vNavCenter.vue";
import vNavBelow from "./variants/vNavBelow.vue";
import cAddressFull from "./components/cAddressFull.vue";

export default {
    components: {
        cCopyTerms,
        cContainer,
        cNewsletter,
        cNewsletterMidi,
        vNavLeft,
        vNavCenter,
        vNavBelow,
        cAddressFull,
    },
    name: "FooterBody",
    props: {
        footer: Object,
    },
    data() {
        return {
            currentMainColor: "",
        };
    },
    computed: {
        footerMainColor() {
            return this.footer.mainColor;
        },
    },
    watch: {
        footerMainColor: {
            handler() {
                this.updateLinkColor();
            },
            immediate: true,
        },
    },
    methods: {
        updateLinkColor() {
            if (this.footer.mainColor === this.currentMainColor) {
                return;
            }
            const newStyle = document.createElement("style");
            newStyle.innerHTML = `
            .footer-link:hover {
                color: ${this.footer.mainColor} !important
              }
            `;

            const existingStyles = document.head.querySelectorAll("style");

            if (existingStyles.length) existingStyles.forEach((style) => style.remove());

            setTimeout(() => {
                document.head && document.head.appendChild(newStyle);
            }, 100);
            this.currentMainColor = this.footer.mainColor;
        },
    },
};
</script>
